import { OPTIONS_INTEGRATION } from 'app-constants'
import { http } from 'hooks'

export function massiveService() {
  function getMassiveWarningByUnityAndContract({ unity, idContract }) {
    return http.get(
      `/v1/massive-warnings/unity/${unity}/contract/${idContract}`,
      OPTIONS_INTEGRATION
    )
  }

  return {
    getMassiveWarningByUnityAndContract,
  }
}
